module.exports = __webpack_public_path__ + "img/9788986698879.75a770d3.jpg";